export class UserPortalVO {
    portalId: string;
    landingUrl: string;
    constructor() {
        this.landingUrl = '';
        this.portalId = '';
    }
}
